import React from 'react'

import Layout from '../components/layout'
import WorkOne from '../components/work/WorkOne'
import WorkProjectsShowcase from '../components/work/WorkProjectsShowcase'
import HomeFour from '../components/home/HomeFour'

const Work = props => (
  <Layout
    lang='pt'
	title="Trabalho"
	meta={{description: 'Trabalhamos com grandes empresas e startups que estão ansiosas por mudar o mundo.'}}
    rootProps={{ className: 'page work' }}
    headerProps={{ isBlue: false }}
  >
    <WorkOne lang="pt" />
    <WorkProjectsShowcase lang="pt" />
    <HomeFour lang="pt" />
  </Layout>
)

export default Work
